export async function copyTextToClipboard(text) {
  return await navigator.clipboard.writeText(text);
}

export async function copyTextFromClipboard() {
  return await navigator.clipboard.readText();
}
